import { Fragment } from 'react';
import Isvg from 'react-inlinesvg';

export function SvgIcon({ icon = '' }: { icon?: string }) {
  const svg = icon ? <Isvg src={icon} /> : '';
  return <Fragment key={`key-${icon}`}>{svg}</Fragment>;
}
